/**
 * URL Detection Utility
 * Detects specific URL patterns and extracts query parameters
 */

/**
 * Check if current page is the "Get My Low Rates" application form
 * @returns true if on /application-form-get-my-low-rates page
 */
export function isGetMyLowRatesPage(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  const pathname = window.location.pathname.toLowerCase()
  return pathname === '/application-form-get-my-low-rates' ||
         pathname === '/application-form-get-my-low-rates/'
}

/**
 * Extract refId from URL query parameters
 * @returns refId string or null if not present
 */
export function getRefIdFromUrl(): string | null {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const urlParams = new URLSearchParams(window.location.search)
    const refId = urlParams.get('refid')

    // Return refId if it exists and is not empty
    return refId && refId.trim().length > 0 ? refId.trim() : null
  } catch (error) {
    console.error('❌ Error parsing URL parameters:', error)
    return null
  }
}

/**
 * Check if pre-fill mode should be activated
 * @returns true if page is /application-form-get-my-low-rates AND refid parameter exists
 */
export function shouldActivatePreFill(): boolean {
  return isGetMyLowRatesPage() && getRefIdFromUrl() !== null
}
